// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"9327c310","453":"467a1b55"}[chunkId] + ".chunk.js";
};